module.exports = __webpack_public_path__ + "nepal.svg?be4ae186c6ffe684dd33ac455734a26b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/nepal.svg
// module id = 244
// module chunks = 10